export const themeType = {
  A: {
    mainBackground: '#3b4664',
    subBackgroundA: '#181f32',
    subBackgroundB: '#252d44',
    buttonTypeA: '#e8e3db',
    buttonTypeB: '#647199',
    buttonTypeC: '#d13f30',
    buttonBorderTypeA: '#b3a296',
    buttonBorderTypeB: '#3d4b72',
    buttonBorderTypeC: '#8f2215',
    buttonHoverTypeA: '#ffffff',
    buttonHoverTypeB: '#a2b3e1',
    buttonHoverTypeC: '#f96c5b',
    fontColorTypeA: '#ffffff',
    fontColorTypeB: '#3f4356',
    fontColorTypeC: '#ffffff',
    fontColorTypeD: '#ffffff',
  },
  B: {
    mainBackground: '#e6e6e6',
    subBackgroundA: '#eeeeee',
    subBackgroundB: '#d4cdcd',
    buttonTypeA: '#e5e4e0',
    buttonTypeB: '#388186',
    buttonTypeC: '#c95302',
    buttonBorderTypeA: '#a09991',
    buttonBorderTypeB: '#1a6067',
    buttonBorderTypeC: '#873901',
    buttonHoverTypeA: '#ffffff',
    buttonHoverTypeB: '#62b5bd',
    buttonHoverTypeC: '#ff8a38',
    fontColorTypeA: '#35362b',
    fontColorTypeB: '#35362b',
    fontColorTypeC: '#ffffff',
    fontColorTypeD: '#ffffff',
  },
  C: {
    mainBackground: '#17062a',
    subBackgroundA: '#1e0836',
    subBackgroundB: '#1e0836',
    buttonTypeA: '#331b4d',
    buttonTypeB: '#56077c',
    buttonTypeC: '#03ddce',
    buttonBorderTypeA: '#891ca0',
    buttonBorderTypeB: '#b91cf3',
    buttonBorderTypeC: '#6efbf2',
    buttonHoverTypeA: '#6b34ac',
    buttonHoverTypeB: '#8631b0',
    buttonHoverTypeC: '#94fff9',
    fontColorTypeA: '#ffe647',
    fontColorTypeB: '#ffe647',
    fontColorTypeC: '#ffffff',
    fontColorTypeD: '#091e26',
  },
};

export const timer = {
  default: '0.3s',
  fast: '0.1s',
  slow: '0.5s',
};

export const size = {
  mobile: '768px',
  desktop: '1024px',
};
